export type ShaderTheme =
  | 'planck_shear'
  | 'particulate_void'
  | 'quantum_grid'
  | 'temporal_freeze'
  | 'synaptic_decay';

export interface ShaderCue {
  theme: ShaderTheme;
  speed: number;       // 0.1 to 3.0
  intensity: number;   // 0.0 to 1.0
  distortion: number;  // 0.0 to 1.0
  gridDensity: number; // 10 to 80
}

export interface ShaderController {
  updateShaderCue(cue: ShaderCue, immediate?: boolean): void;
  resize(width: number, height: number, dpr?: number): void;
  pause(): void;
  resume(): void;
  destroy(): void;
}

export const DEFAULT_SHADER_CUE: ShaderCue = {
  theme: 'planck_shear',
  speed: 1.0,
  intensity: 0.5,
  distortion: 0.2,
  gridDensity: 32,
};
